import { useBoxName } from '@fff-web/fff-payments';
import { useReactivatePlanDataContext } from '../../utils/ContextProviders/ReactivatePlanDataContext';
import { CouponResponseData } from '../../utils/ContextProviders/ReactivatePlanDataContext/ReactivatePlanDataContext';
import { IPlanCode } from '../../utils/Interfaces';
import * as styles from './PromotionBannerContainer.module.scss';

interface PromotionBannerContainerProps {
  onClick(): void;
}

export const SEASONAL_PROMO_CODE = 'mygift';
const MYSTERY_LABEL = 'MYSTERY';
const NON_MYSTERY_LABEL = 'NON_MYSTERY';

interface GetDiscountMessageProps {
  discount: number;
  boxName: string;
}

export const getDiscountMessage = ({ discount, boxName }: GetDiscountMessageProps) => {
  const discountFormatted = Math.abs(discount).toFixed(2);
  return `Yay! You're getting $${discountFormatted} off your ${boxName}. All discounts will be applied at checkout.`;
};

export const getMysteryMessage = (boxName: string) => {
  return `Yay! You're getting a FREE Mystery Gift with your ${boxName}. This offer will be applied at checkout.`;
};

export const getNoCouponMessage = (boxName: string) => {
  return `Hurry! Claim 20% off your ${boxName} when signing up for a Seasonal Membership.`;
};

const PromotionBannerContainer = ({ onClick }: PromotionBannerContainerProps) => {
  const {
    couponData,
    discount,
    onPlanChange,
    selectedPlanCode,
    handleCallCouponApi,
    loading: isCouponLoading,
    handleOnChange: handleCouponChange,
  } = useReactivatePlanDataContext();

  const { boxName } = useBoxName();

  if (isCouponLoading) {
    return null;
  }

  const renderMessage = () => {
    // TODO: Please review this casting since signature does not match.
    const { couponType, previewDescription } = couponData as CouponResponseData;

    if (previewDescription) return previewDescription;

    if (couponType === MYSTERY_LABEL || couponType === NON_MYSTERY_LABEL) {
      return getMysteryMessage(boxName);
    }

    return getDiscountMessage({ discount: +discount, boxName });
  };

  const handleClick = () => {
    if (couponData) {
      onClick();
      return;
    }

    if (selectedPlanCode === IPlanCode.SEASONAL) {
      handleCallCouponApi?.(SEASONAL_PROMO_CODE);
    }

    if (selectedPlanCode === IPlanCode.ANNUAL) {
      handleCouponChange?.(undefined, SEASONAL_PROMO_CODE);
      onPlanChange(IPlanCode.SEASONAL);
    }

    onClick();
  };

  return (
    <div
      className={styles.container}
      onClick={handleClick}
      role="button"
      onKeyDown={handleClick}
      tabIndex={0}
    >
      <p>{couponData ? renderMessage() : getNoCouponMessage(boxName)}</p>
    </div>
  );
};

export default PromotionBannerContainer;
